import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../services/i18nService';

import OptionButton from './OptionButton';

const InstructionsButton = ({ clickHandler, a11yAttributes }) => {
    return (<OptionButton
        iconClass="fa fa-fw fa-info-circle"
        clickHandler={clickHandler}
        title={t('options.testInstructions')}
        a11yAttributes={a11yAttributes}
    />);
};

InstructionsButton.propTypes = {
    clickHandler: PropTypes.func.isRequired,
    a11yAttributes: PropTypes.object,
};

export default InstructionsButton;
